import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {ClickerStateStore} from '@/stores/ClickerStateStore/ClickerStateStore';
import {DateUtils} from '@/utils/DateUtils';

import {ProjectDate} from '../ProjectDate/ProjectDate';

export class ClickerIncomeUpdater {
  constructor(private readonly clickerStateStore: ClickerStateStore, private readonly projectDate: ProjectDate) {}

  public startUpdateGame(): void {
    this.projectDate.subscribe(this.update);
  }

  private update = (): void => {
    const deltaInSeconds = this.projectDate.delta / 1000;

    const {maxEnergy, totalIncomePerHour, energyRecoveryInMinutes} = this.clickerStateStore.getState();

    this.clickerStateStore.addEnergy(this.getEnergyPerSecond(maxEnergy, energyRecoveryInMinutes) * deltaInSeconds);
    this.clickerStateStore.addPoints(this.getIncomePerSecond(totalIncomePerHour) * deltaInSeconds);
  };

  private getIncomePerSecond(totalIncomePerHour: number): number {
    return totalIncomePerHour / DateUtils.hoursToSeconds(1);
  }

  private getEnergyPerSecond(maxEnergy: number, recoveryTimeInMinutes: number): number {
    return maxEnergy / DateUtils.daysToSeconds(recoveryTimeInMinutes / 60 / 24);
  }
}

injected(ClickerIncomeUpdater, DI_TOKENS.clickerStateStore, DI_TOKENS.projectDate);
